/* T8 Product — PDP 2.0: gallery, Size × Material × Frame variant resolution, price / discount / offer chip,
   stock message, Add to Cart (TamyraCart → T8Cart → /cart/add.js, then `tamyra:cart:updated`),
   pin-code + countdown + delivery timeline, size-guide modal (chart + visualiser, #size-guide hash). */
(function () {
  'use strict';

  function formatMoney(cents, fmt) {
    var f = fmt || 'Rs. {{amount}}';
    var n = (cents / 100);
    function thousands(s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    var out;
    if (/amount_no_decimals/.test(f)) out = thousands(String(Math.round(n)));
    else if (/amount_with_comma_separator/.test(f)) out = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else out = thousands(n.toFixed(2));
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }

  function parseSize(str) {
    var m = String(str || '').toLowerCase().match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
  }

  function initGallery(pdp) {
    var gal = pdp.querySelector('[data-t8-gallery]'); if (!gal || gal.dataset.ready) return null;
    gal.dataset.ready = '1';
    var slides = gal.querySelectorAll('.t8-gal__slide');
    var thumbs = gal.querySelectorAll('.t8-gal__thumb');
    var rail = gal.querySelector('[data-t8-gal-thumbs]');
    var more = gal.querySelector('[data-t8-gal-more]');
    var index = 0;
    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === index);
        var v = s.querySelector('video'); if (v && k !== index) v.pause();
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === index);
        if (k === index) { t.setAttribute('aria-current', 'true'); t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); }
        else t.removeAttribute('aria-current');
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(Number(t.dataset.index)); }); });
    var prev = gal.querySelector('[data-t8-gal-prev]'), next = gal.querySelector('[data-t8-gal-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    // swipe on the stage
    var stage = gal.querySelector('.t8-gal__stage'), x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    });
    if (rail && more) {
      function checkMore() { more.hidden = rail.scrollWidth - rail.clientWidth - rail.scrollLeft < 8; }
      more.addEventListener('click', function () { rail.scrollBy({ left: 184, behavior: 'smooth' }); });
      rail.addEventListener('scroll', checkMore, { passive: true });
      window.addEventListener('resize', checkMore);
      checkMore();
    }
    // variant featured media → slide by data-media (the preview slide may be first and the artwork-only media hidden)
    function showMedia(pos) {
      var k = -1;
      slides.forEach(function (s, i) { if (k === -1 && Number(s.dataset.media) === pos) k = i; });
      if (k !== -1) show(k);
    }
    var api = { show: show, showMedia: showMedia, index: function () { return index; } };
    gal.t8Gallery = api;
    return api;
  }

  function initPillRails(pdp) {
    pdp.querySelectorAll('[data-t8-pillrail]').forEach(function (wrap) {
      if (wrap.dataset.ready) return; wrap.dataset.ready = '1';
      var track = wrap.querySelector('.t8-pdp__pills--scroll'); if (!track) return;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 't8-pdp__railbtn'; btn.setAttribute('aria-label', 'Scroll options');
      btn.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12.57 6.29 8 10.86 3.43 6.29"/></svg>';
      wrap.appendChild(btn);
      function check() {
        wrap.classList.toggle('has-more', track.scrollWidth - track.clientWidth - track.scrollLeft > 8);
        // centre the › on the pills / swatch images (the row carries extra top padding for the badges)
        var o = [].find.call(track.querySelectorAll('.t8-pdp__swatchimg, .t8-pdp__pill'), function (e) { return e.offsetHeight; });
        if (o && o.offsetHeight) { var r = o.getBoundingClientRect(), w = wrap.getBoundingClientRect(); btn.style.top = (r.top - w.top + r.height / 2) + 'px'; }
      }
      btn.addEventListener('click', function () { track.scrollBy({ left: Math.max(160, track.clientWidth * .6), behavior: 'smooth' }); });
      track.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      // options that don't exist for the chosen material are hidden later (is-missing): re-check whenever they change
      if (window.MutationObserver) new MutationObserver(function () { requestAnimationFrame(check); }).observe(track, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
      track.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', check, { once: true }); });
      check(); requestAnimationFrame(check); setTimeout(check, 400);
    });
  }

  function initSizeGuide(pdp, form) {
    var modal = pdp.querySelector('[data-t8-size-guide]'); if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = '1';
    var dialog = modal.querySelector('.t8-sg__dialog');
    var opener = null;
    var tabs = modal.querySelectorAll('[data-t8-sg-tab]');
    var panels = modal.querySelectorAll('[data-t8-sg-panel]');
    var title = modal.querySelector('[data-t8-sg-title]');

    function showTab(name) {
      tabs.forEach(function (t) { var on = t.dataset.t8SgTab === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
      panels.forEach(function (p) { p.hidden = p.dataset.t8SgPanel !== name; });
      if (title && title.dataset[name]) title.textContent = title.dataset[name];
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { showTab(t.dataset.t8SgTab); }); });

    function focusables() {
      return Array.prototype.filter.call(dialog.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])'), function (el) { return !el.hidden && el.offsetParent !== null; });
    }
    function open(tab) {
      opener = document.activeElement;
      modal.hidden = false; document.body.classList.add('t8-sg-open');
      if (tab) showTab(tab);
      syncFromForm();
      setTimeout(function () { (focusables()[0] || dialog).focus(); }, 0);
    }
    function close() {
      modal.hidden = true; document.body.classList.remove('t8-sg-open');
      if (/^#size-guide/.test(location.hash) && window.history && window.history.replaceState) window.history.replaceState(null, '', location.pathname + location.search);
      if (opener && opener.focus) opener.focus();
    }
    modal.querySelectorAll('[data-t8-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    pdp.querySelectorAll('[data-t8-size-guide-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open('chart'); });
    });

    /* ---- visualiser ---- */
    var svg = modal.querySelector('[data-t8-vis]');
    var pills = modal.querySelectorAll('[data-t8-vis-size]');
    var currentSize = pills.length ? pills[0].dataset.t8VisSize : '';
    function sizeRadios() { return form ? form.querySelectorAll('.t8-pdp__opt--size input[type="radio"]') : []; }
    function syncFromForm() {
      var checked = Array.prototype.filter.call(sizeRadios(), function (r) { return r.checked; })[0];
      if (checked) setSize(checked.value, false);
    }
    function setSize(value, pushToForm) {
      pills.forEach(function (p) { var on = p.dataset.t8VisSize.toLowerCase() === String(value).toLowerCase(); p.classList.toggle('is-active', on); p.setAttribute('aria-checked', String(on)); });
      draw(value);
      if (pushToForm) {
        sizeRadios().forEach(function (r) { if (r.value.toLowerCase() === String(value).toLowerCase() && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } });
      }
    }
    pills.forEach(function (p) { p.addEventListener('click', function () { setSize(p.dataset.t8VisSize, true); }); });

    function setRect(el, x, y, w, h) { el.setAttribute('x', x); el.setAttribute('y', y); el.setAttribute('width', w); el.setAttribute('height', h); }
    function chip(name, cx, text) {
      var g = svg.querySelector('[data-t8-vis-chip="' + name + '"]'); if (!g) return;
      var t = g.querySelector('text'), r = g.querySelector('rect');
      t.textContent = text;
      var w = Math.round(Math.max(60, (t.getComputedTextLength ? t.getComputedTextLength() : text.length * 7.2) + 32));
      r.setAttribute('width', w); r.setAttribute('x', Math.round(cx - w / 2)); t.setAttribute('x', Math.round(cx));
    }
    function draw(value) {
      if (!svg || !value) return;
      currentSize = value;
      var s = parseSize(value); if (!s) return;
      var W = 766, FLOOR = 400, TOP = 24, GAP = 60, availH = FLOOR - TOP;
      var laptop = svg.querySelector('[data-t8-vis-laptop]'), sofa = svg.querySelector('[data-t8-vis-sofa]'), frame = svg.querySelector('[data-t8-vis-frame]');
      // px per inch: laptop (12in wide) at up to 20px/in, otherwise sofa (84in wide) at up to 6px/in
      var scale = Math.min(20, availH / s.h, (W - 80 - GAP) / (12 + s.w));
      var useSofa = scale < 9;
      if (useSofa) scale = Math.min(6, availH / s.h, (W - 80 - GAP) / (84 + s.w));
      var objW = (useSofa ? 84 : 12) * scale;
      var fw = s.w * scale, fh = s.h * scale;
      var total = objW + GAP + fw;
      var x0 = Math.round((W - total) / 2);
      var fx = x0 + objW + GAP, fy = FLOOR - 2 - fh;
      setRect(frame, fx, fy, fw, fh);
      laptop.setAttribute('visibility', useSofa ? 'hidden' : 'visible');
      sofa.setAttribute('visibility', useSofa ? 'visible' : 'hidden');
      if (!useSofa) {
        var lh = 7.9 * scale, baseH = Math.max(8, 0.6 * scale), bezelW = 11.6 * scale, scrW = 11.2 * scale, scrH = 7.3 * scale;
        var ly = FLOOR - baseH - lh;
        setRect(laptop.querySelector('[data-part="bezel"]'), x0 + (objW - bezelW) / 2, ly, bezelW, lh);
        setRect(laptop.querySelector('[data-part="screen"]'), x0 + (objW - scrW) / 2, ly + 0.2 * scale, scrW, scrH);
        setRect(laptop.querySelector('[data-part="base"]'), x0, FLOOR - baseH, objW, baseH);
        chip('object', x0 + objW / 2, '13 inch laptop - 12 inch wide');
      } else {
        var sh = 34 * scale, sy = FLOOR - sh, legH = 2 * scale, armW = 7 * scale, seatH = 9 * scale, cushW = (84 - 20) * scale / 3 - 6, cushH = 14 * scale;
        setRect(sofa.querySelector('[data-part="back"]'), x0, sy, objW, sh - legH);
        setRect(sofa.querySelector('[data-part="arm-l"]'), x0, sy + 8 * scale, armW, sh - legH - 8 * scale);
        setRect(sofa.querySelector('[data-part="arm-r"]'), x0 + objW - armW, sy + 8 * scale, armW, sh - legH - 8 * scale);
        for (var i = 0; i < 3; i++) setRect(sofa.querySelector('[data-part="cushion-' + (i + 1) + '"]'), x0 + 10 * scale + i * (cushW + 6) + 3, sy + 6 * scale, cushW, cushH);
        setRect(sofa.querySelector('[data-part="seat"]'), x0 + armW, FLOOR - legH - seatH, objW - armW * 2, seatH);
        setRect(sofa.querySelector('[data-part="leg-l"]'), x0 + 6 * scale, FLOOR - legH, 2 * scale, legH);
        setRect(sofa.querySelector('[data-part="leg-r"]'), x0 + objW - 8 * scale, FLOOR - legH, 2 * scale, legH);
        chip('object', x0 + objW / 2, '34 in high, 84 in wide - sofa');
      }
      chip('frame', fx + fw / 2, s.w + ' x ' + s.h + ' inch');
    }
    if (pills.length) draw(pills[0].dataset.t8VisSize);
    // keep the visualiser in step with the form
    if (form) form.addEventListener('change', function (e) { if (e.target.type === 'radio' && e.target.closest('.t8-pdp__opt--size')) setSize(e.target.value, false); });
    // redraw when the tab becomes visible (text metrics are 0 while hidden)
    tabs.forEach(function (t) { t.addEventListener('click', function () { if (t.dataset.t8SgTab === 'visualise') draw(currentSize); }); });
    // #size-guide / #size-guide-visualise open the modal (after everything above is wired up)
    function checkHash() { var m = location.hash.match(/^#size-guide(?:-(visualise|chart))?$/); if (m && modal.hidden) { var tab = (m[1] === 'visualise' && svg) ? 'visualise' : 'chart'; open(tab); if (tab === 'visualise') draw(currentSize); } }
    window.addEventListener('hashchange', checkHash);
    checkHash();
  }

  function initDelivery(pdp, cfg) {
    var delivery = pdp.querySelector('[data-t8-delivery]'); if (!delivery || delivery.dataset.ready) return;
    delivery.dataset.ready = '1';
    // dispatch: ordered before the cut-off hour -> +ship-min days (0 = same day), after it -> +ship-max days (1 = next day);
    // Sundays skipped when set; delivered = dispatch + deliver(-max) days. All values come from the section settings.
    var D = delivery.dataset, cutoffHour = Number(D.cutoff || 16), before = Number(D.shipMin || 0), after = Number(D.shipMax || 1),
        dMin = Number(D.deliver || 0), dMax = Math.max(dMin, Number(D.deliverMax || 0)), skipSun = D.skipSunday === 'true';
    var countdown = delivery.querySelector('[data-t8-countdown]'), etaDates = delivery.querySelectorAll('[data-t8-eta-date]'), etaWrap = delivery.querySelector('[data-t8-eta-wrap]');
    var fmt = function (d) { return d.toLocaleDateString('en-IN', { month: 'short', day: 'numeric' }); };
    var fmtLong = function (d) { return d.toLocaleDateString('en-GB', { weekday: 'long' }) + ', ' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }); };   // Monday, 26 Oct
    function shift(d, n) { d = new Date(d); d.setDate(d.getDate() + n); return d; }
    function range(x, y) { return x.getMonth() === y.getMonth() ? x.getDate() + ' – ' + fmt(y) : fmt(x) + ' – ' + fmt(y); }   // 29 – 30 Oct / 31 Oct – 1 Nov
    function noSunday(d) { return skipSun && d.getDay() === 0 ? shift(d, 1) : d; }
    function dispatchDate(now) { return noSunday(shift(now, now.getHours() < cutoffHour ? before : after)); }
    function paintDates() {
      // dispatch and delivery each show two consecutive days (one buffer day): 29 – 30 Oct, 1 – 2 Nov
      var now = new Date(), disp = dispatchDate(now), disp2 = noSunday(shift(disp, 1)), a = shift(disp, dMin), b = noSunday(shift(disp, dMax + 1));
      var dispatch = delivery.querySelector('[data-t8-tl="dispatch"]'), delivered = delivery.querySelector('[data-t8-tl="delivered"]');
      if (dispatch) dispatch.textContent = disp.toDateString() === now.toDateString() ? (cfg.todayText || 'Today') + ' – ' + fmt(disp2) : range(disp, disp2);
      if (delivered) delivered.textContent = range(a, b);
      etaDates.forEach(function (el) { el.textContent = fmtLong(b); });
    }
    function cdText(secs) { var h = Math.floor(secs / 3600), m = Math.floor(secs % 3600 / 60), sc = secs % 60; return (h ? h + (h === 1 ? ' hr ' : ' hrs ') : '') + m + (m === 1 ? ' min ' : ' mins ') + sc + (sc === 1 ? ' sec' : ' secs'); }
    function tick() {
      if (!countdown) return;
      var now = new Date(), cut = new Date(now); cut.setHours(cutoffHour, 0, 0, 0);
      if (cut <= now) cut = shift(cut, 1);
      var secs = Math.max(0, Math.floor((cut - now) / 1000));
      countdown.textContent = cdText(secs);
      if (now.getSeconds() === 0 || !tick.painted) { paintDates(); tick.painted = true; }   // dates only need a refresh once a minute
    }
    tick(); setInterval(tick, 1000);   // every second (the countdown shows seconds)
    var pinForm = delivery.querySelector('[data-t8-pin-form]'), pin = delivery.querySelector('[data-t8-pin]'), note = delivery.querySelector('[data-t8-pin-note]');
    function showDate() { delivery.classList.add('is-checked'); if (etaWrap) etaWrap.hidden = false; paintDates(); }
    if (pinForm && pin) {
      var noteHtml = note ? note.innerHTML : '';
      pinForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var ok = /^[1-9][0-9]{5}$/.test(pin.value.trim());
        pin.classList.toggle('is-invalid', !ok);
        if (note) {
          note.classList.toggle('is-ok', ok); note.classList.toggle('is-bad', !ok);
          note.textContent = ok ? (cfg.pinOk || 'Delivering to {pin}').replace('{pin}', pin.value.trim()) : (cfg.pinBad || 'Please enter a valid 6-digit PIN code.');
          if (!ok) setTimeout(function () { note.classList.remove('is-bad'); note.innerHTML = noteHtml; }, 4000);
        }
        if (!ok) { pin.focus(); return; }
        try { sessionStorage.setItem('tamyra:pin', pin.value.trim()); } catch (err) {}
        showDate();
      });
      try { var saved = sessionStorage.getItem('tamyra:pin'); if (saved) { pin.value = saved; showDate(); } } catch (err) {}
    }
  }

  function initMount(pdp) {
    var dlg = pdp.querySelector('[data-t8-mount]'); if (!dlg || dlg.dataset.ready) return; dlg.dataset.ready = '1';
    var last = null;
    function open(btn) { last = btn; dlg.hidden = false; document.body.classList.add('t8-sg-open'); var c = dlg.querySelector('.t8-sg__close'); if (c) c.focus(); }
    function close() { dlg.hidden = true; document.body.classList.remove('t8-sg-open'); if (last) last.focus(); }
    pdp.querySelectorAll('[data-t8-mount-open]').forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    dlg.querySelectorAll('[data-t8-mount-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dlg.hidden) close(); });
  }

  /* ---------- phones: the gallery docks at the top (smaller, no thumbnails) while the options scroll under it, until the
     product grid ends, so every size / frame / mount change is seen as it happens. The gallery box keeps its height, so
     nothing below jumps; it sits under the site header whenever that slides back in. ---------- */
  function initDock(pdp) {
    var gal = pdp.querySelector('.t8-pdp__gallery'), grid = pdp.querySelector('.t8-pdp__grid');
    if (!gal || !grid || gal.dataset.dock) return; gal.dataset.dock = '1';
    var mq = window.matchMedia('(max-width: 860px)'), docked = false, raf = 0;
    var head = document.querySelector('.shopify-section-t8-header');
    function headBottom() {
      if (!head || getComputedStyle(head).position !== 'sticky') return 0;
      var r = head.getBoundingClientRect(); return r.bottom > 0 ? Math.round(r.bottom) : 0;
    }
    function set(on) {
      if (on === docked) return; docked = on;
      if (on) gal.style.height = gal.offsetHeight + 'px'; else gal.style.height = '';
      gal.classList.toggle('is-docked', on);
    }
    function update() {
      raf = 0;
      if (!mq.matches) { set(false); gal.style.top = ''; return; }
      var top = headBottom();
      gal.style.top = top + 'px';
      set(grid.getBoundingClientRect().top < top - 8);
    }
    var settle = 0;
    function queue() {
      if (!raf) raf = requestAnimationFrame(update);
      clearTimeout(settle); settle = setTimeout(update, 420);   // once the header has finished sliding in / out
    }
    window.addEventListener('scroll', queue, { passive: true });
    if (head) head.addEventListener('transitionend', queue);
    window.addEventListener('resize', function () { set(false); queue(); });
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-t8-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = '1';

      var gallery = initGallery(pdp);
      initPillRails(pdp);
      initDock(pdp);

      var form = pdp.querySelector('[data-t8-pdp-form]');
      var cfgEl = pdp.querySelector('[data-t8-config]'), dataEl = pdp.querySelector('[data-t8-variants]');
      var cfg = {}, variants = [];
      try { cfg = cfgEl ? JSON.parse(cfgEl.textContent) : {}; variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}

      initDelivery(pdp, cfg);
      initMount(pdp);
      initSizeGuide(pdp, form);

      /* quantity */
      var qtyInput = pdp.querySelector('input[name="quantity"]');
      pdp.querySelectorAll('[data-t8-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () { var n = parseInt(qtyInput.value, 10) || 1; qtyInput.value = Math.max(1, n + Number(btn.dataset.t8Qty)); qtyInput.dispatchEvent(new Event('change', { bubbles: true })); });
      });

      var qtySel = pdp.querySelector('[data-t8-qtyselect]');
      if (qtySel && qtyInput) {
        qtySel.addEventListener('change', function () { qtyInput.value = qtySel.value; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); });
        qtyInput.addEventListener('change', function () { var n = Math.min(10, Math.max(1, parseInt(qtyInput.value, 10) || 1)); if (String(n) !== qtySel.value) qtySel.value = String(n); });
      }

      /* share / wishlist / copy */
      var shareBtn = pdp.querySelector('[data-t8-share]');
      if (shareBtn) shareBtn.addEventListener('click', function () {
        var data = { title: document.title, url: window.location.href };
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { shareBtn.setAttribute('aria-label', 'Link copied'); setTimeout(function () { shareBtn.setAttribute('aria-label', 'Share'); }, 1500); });
      });
      var wishBtn = pdp.querySelector('[data-t8-wishlist]');
      if (wishBtn) {
        var key = 't8-wishlist', handle = wishBtn.dataset.t8Wishlist || pdp.dataset.handle || '';   /* same list as the product cards and the wishlist page */
        function readWish() { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
        wishBtn.setAttribute('aria-pressed', String(readWish().indexOf(handle) !== -1));
        wishBtn.addEventListener('click', function () {
          var list = readWish(), i = list.indexOf(handle);
          if (i === -1) list.unshift(handle); else list.splice(i, 1);
          try { localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
          wishBtn.setAttribute('aria-pressed', String(i === -1));
          wishBtn.setAttribute('aria-label', i === -1 ? 'Remove from wishlist' : 'Save to wishlist');
          document.dispatchEvent(new CustomEvent('t8:wishlist:updated', { detail: { handle: handle, list: list, added: i === -1 } }));
        });
      }
      pdp.querySelectorAll('[data-t8-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.dataset.t8Copy || '';
          var done = function () { btn.classList.add('is-copied'); setTimeout(function () { btn.classList.remove('is-copied'); }, 1600); };
          if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
        });
      });

      if (!form) return;

      /* ---------- variants ---------- */
      var idInput = form.querySelector('[data-t8-variant-id]');
      var priceEl = pdp.querySelector('[data-t8-price]'), compareEl = pdp.querySelector('[data-t8-compare]');
      var discEl = pdp.querySelector('[data-t8-discount]'), discText = pdp.querySelector('[data-t8-discount-text]');
      var offerEl = pdp.querySelector('[data-t8-offer]');
      var stockEl = pdp.querySelector('[data-t8-stock]'), stockText = pdp.querySelector('[data-t8-stock-text]');
      var atc = pdp.querySelector('[data-t8-atc]'), atcText = pdp.querySelector('[data-t8-atc-text]');
      var frameLabel = pdp.querySelector('[data-t8-frame-label]');
      var optionRadios = function () { return form.querySelectorAll('input[type="radio"][data-opt-position]'); };

      function chosen() {
        var out = [];
        optionRadios().forEach(function (r) { if (r.checked) out[Number(r.dataset.optPosition) - 1] = r.value; });
        return out;
      }
      function match(sel) {
        return variants.filter(function (v) { return sel.every(function (val, i) { return val === undefined || v.options[i] === val; }); })[0];
      }
      // Each option is filtered by the options BEFORE it (Size → Material → Frame) so a change upstream
      // never locks the shopper out; downstream conflicts are healed in update().
      /* chart sizes the product has no variant for yet (shown on prints, ordered on WhatsApp) */
      function sizeRadio() { return form.querySelector('.t8-pdp__opt--size input[type="radio"]:checked'); }
      function sizeOrphan() {
        var r = sizeRadio(); if (!r) return false;
        var i = Number(r.dataset.optPosition) - 1;
        return !variants.some(function (v) { return v.options[i] === r.value; });
      }
      function refreshAvailability() {
        var sel = chosen(), orphan = sizeOrphan(), sr = sizeRadio(), sizePos = sr ? Number(sr.dataset.optPosition) - 1 : -1;
        var mr = form.querySelector('.t8-pdp__opt--material input[type="radio"]:checked'), onCanvas = !mr || /canvas/i.test(mr.value);
        optionRadios().forEach(function (r) {
          var pos = Number(r.dataset.optPosition) - 1;
          var probe = sel.slice(0, pos); probe[pos] = r.value;
          var exists = variants.some(function (v) { return probe.every(function (val, i) { return val === undefined || v.options[i] === val; }); });
          if (r.closest('.t8-pdp__opt--size') && cfg.wa) exists = true;   /* every chart size stays selectable */
          if (orphan && pos > sizePos) exists = true;                       /* on-request size: any material / frame can be asked for */
          var sellable = variants.some(function (v) { return v.available && probe.every(function (val, i) { return val === undefined || v.options[i] === val; }); });
          if (cfg.qv) { exists = true; sellable = true; }                    /* quick view: every option stays selectable; a missing combination is ordered on WhatsApp */
          if (!onCanvas && r.closest('.t8-pdp__swatch') && /float|wrap/i.test(r.value)) exists = false;   /* floater frames and Gallery Wrap are for canvas only */
          r.disabled = !exists;
          var label = r.closest('label');
          label.classList.toggle('is-missing', !exists);
          label.classList.toggle('is-unavailable', exists && !sellable);
        });
      }
      function paintOffer(v) {
        if (!offerEl) return;
        var pct = Number(offerEl.dataset.percent || cfg.offerPercent || 0);
        var tpl = offerEl.dataset.template || '';
        var price = Math.round(v.price * (100 - pct) / 10000) * 100;   /* whole rupees */
        var html = tpl.replace('{price}', formatMoney(price, cfg.moneyFormat).replace(/[.,]00(?=\D*$)/, '').replace('Rs.', 'Rs')).replace('{percent}', pct).replace('{code}', '<b>' + (offerEl.dataset.code || '') + '</b>');
        offerEl.innerHTML = html;
      }
      function update() {
        if (!variants.length) return;
        refreshAvailability();
        var healed = false, groups = {};
        optionRadios().forEach(function (r) { (groups[r.name] = groups[r.name] || []).push(r); });
        Object.keys(groups).forEach(function (name) {
          var list = groups[name], checked = list.filter(function (r) { return r.checked; })[0];
          if (!checked || checked.disabled) { var first = list.filter(function (r) { return !r.disabled; })[0]; if (first) { first.checked = true; healed = true; } }
        });
        if (healed) refreshAvailability();

        if (frameLabel) { var fr = form.querySelector('.t8-pdp__opt--frame input[type="radio"]:checked'); if (fr) frameLabel.textContent = fr.dataset.label || fr.value; }
        // Mount is offered with Art Paper only: hide it for Canvas and select "No"
        var mat = form.querySelector('.t8-pdp__opt--material input[type="radio"]:checked'), mountSet = form.querySelector('.t8-pdp__opt--mount');
        if (mountSet) {
          var fsel = form.querySelector('.t8-pdp__opt--frame input[type="radio"]:checked');
          var canvas = !!(mat && /canvas/i.test(mat.value)) || !!(fsel && /rolled|wrap/i.test(fsel.value));   /* no mount on canvas, rolled art or gallery wrap */
          mountSet.hidden = canvas;
          if (canvas) { var no = Array.prototype.filter.call(mountSet.querySelectorAll('input[type="radio"]'), function (r) { return /^no$/i.test(r.value.trim()) && !r.disabled; })[0]; if (no && !no.checked) { no.checked = true; refreshAvailability(); } }
        }

        var v = match(chosen());
        if (!v && cfg.wa && (sizeOrphan() || cfg.qv)) {   /* size not in the catalogue yet: made to order, confirmed on WhatsApp */
          form.dataset.wa = '1';
          if (atc) { atc.disabled = false; if (atcText) atcText.textContent = cfg.waText || 'Order on WhatsApp'; }
          if (priceEl) priceEl.textContent = cfg.onRequestText || 'Price on request';
          if (compareEl) compareEl.hidden = true;
          if (discEl) discEl.hidden = true;
          if (offerEl) offerEl.closest('.t8-pdp__offer').hidden = true;
          if (stockEl) stockEl.hidden = true;
          return;
        }
        delete form.dataset.wa;
        if (offerEl) offerEl.closest('.t8-pdp__offer').hidden = false;
        if (!v) {
          if (atc) { atc.disabled = true; if (atcText) atcText.textContent = cfg.unavailableText || "This combination isn't available"; }
          if (stockEl) stockEl.hidden = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price_f;
        var hasCompare = v.compare && v.compare > v.price;
        if (compareEl) { compareEl.hidden = !hasCompare; if (hasCompare) compareEl.textContent = v.compare_f; }
        if (discEl) { discEl.hidden = !hasCompare; if (hasCompare && discText) discText.textContent = Math.round((v.compare - v.price) * 100 / v.compare) + '%'; }
        paintOffer(v);
        if (atc) { atc.disabled = !v.available; if (atcText) atcText.textContent = v.available ? (cfg.atcText || 'Add to Cart') : (cfg.soldOutText || 'Sold out'); }
        if (stockEl) {
          var txt = '';
          if (!v.available) txt = cfg.soldOutText || 'Sold out';
          else if (cfg.isPainting) txt = (cfg.onlyLeftText || 'Only {qty} in stock').replace('{qty}', 1);   /* an original painting is one piece */
          else if (v.tracked && v.qty > 0 && v.qty <= (cfg.lowStockAt || 5)) txt = v.qty <= 1 ? (cfg.onlyLeftText || 'Only {qty} in stock').replace('{qty}', v.qty) : (cfg.lowStockText || 'Low stock');
          else if (cfg.inStockText) txt = cfg.inStockText;
          stockEl.classList.toggle('t8-pdp__stock--ok', v.available && !cfg.isPainting && !(v.tracked && v.qty <= (cfg.lowStockAt || 5)));
          if (stockText) stockText.textContent = txt;
          stockEl.hidden = !txt;
        }
        if (gallery && typeof v.media === 'number' && !firstUpdate) gallery.showMedia(v.media);
        if (window.history && window.history.replaceState && /\/products\//.test(location.pathname)) {
          var url = new URL(location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url);
        }
        pdp.dispatchEvent(new CustomEvent('tamyra:variant', { detail: { options: v.options, id: v.id, variant: v }, bubbles: true }));
      }
      var firstUpdate = true;
      form.addEventListener('change', function (e) { if (e.target.type === 'radio' && e.target.dataset.optPosition) update(); });
      update();
      firstUpdate = false;

      /* ---------- add to cart ---------- */
      form.addEventListener('submit', function (e) {
        if (form.dataset.wa === '1' && cfg.wa) {
          e.preventDefault();
          var opts = Array.prototype.map.call(form.querySelectorAll('input[type="radio"][data-opt-position]:checked'), function (r) { return r.dataset.label || r.value; }).join(', ');
          var m = 'Hi! I would like to order "' + (cfg.productTitle || document.title) + '" in ' + opts + '. Please share the price.';
          window.open(cfg.wa + (cfg.wa.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(m), '_blank', 'noopener');
          return;
        }
        var id = idInput && Number(idInput.value); if (!id) return;
        e.preventDefault();
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var props = {};
        form.querySelectorAll('[data-t8-property]:checked').forEach(function (r) { var m = r.name.match(/^properties\[(.+)\]$/); if (m) props[m[1]] = r.value; });
        var label = atcText ? atcText.textContent : '';
        if (atc) { atc.disabled = true; if (atcText) atcText.textContent = cfg.addingText || 'Adding…'; }
        var done = function (added) {
          if (atc) { atc.disabled = false; if (atcText) atcText.textContent = cfg.addedText || 'Added to cart'; atc.classList.add('is-added'); }
          setTimeout(function () { if (atcText) atcText.textContent = label; if (atc) atc.classList.remove('is-added'); }, 1800);
          document.dispatchEvent(new CustomEvent('tamyra:cart:updated', { detail: { added: added, id: id, quantity: qty } }));
        };
        var fail = function (err) {
          if (atc) { atc.disabled = false; if (atcText) atcText.textContent = label; }
          if (err && err.message && !/cart/i.test(location.pathname)) alert(err.message); else form.submit();
        };
        var item = { id: id, quantity: qty };
        if (Object.keys(props).length) item.properties = props;
        if (window.TamyraCart && typeof window.TamyraCart.add === 'function') {
          Promise.resolve(window.TamyraCart.add([item])).then(done).catch(fail);
        } else if (window.T8Cart && typeof window.T8Cart.add === 'function' && !item.properties) {
          Promise.resolve(window.T8Cart.add(id, qty)).then(done).catch(fail);
        } else {
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
            .then(done).catch(fail);
        }
      });

      initPurchase(pdp, form, cfg, priceEl, compareEl);
    });
  }

  /* ---------- Buy Now + sticky purchase bar ----------
     Buy Now (column + bar): POST the main form to /cart/add.js, then /checkout. The bar mirrors the main form
     (price, options, Add to Cart state) and shows once [data-t8-atc] has scrolled above the viewport, hiding at the footer. */
  function initPurchase(pdp, form, cfg, priceEl, compareEl) {
    var bar = pdp.querySelector('[data-t8-sticky]'), buyBtns = pdp.querySelectorAll('[data-t8-buynow]');
    if (!bar && !buyBtns.length) return;
    var atc = pdp.querySelector('[data-t8-atc]'), atcText = pdp.querySelector('[data-t8-atc-text]');
    var idInput = form.querySelector('[data-t8-variant-id]');
    var sAtc = bar && bar.querySelector('[data-t8-sticky-atc]');
    var sPrice = bar && bar.querySelector('[data-t8-sticky-price]'), sCompare = bar && bar.querySelector('[data-t8-sticky-compare]');
    var sOpts = bar && bar.querySelector('[data-t8-sticky-opts]');
    var buyLabel = cfg.buyNowText || 'Buy Now', busy = false;
    function setText(btn, s) { var t = btn.querySelector('[data-t8-btn-text]') || btn; if (t.textContent !== s) t.textContent = s; }
    function setErr(msg, btn) {
      pdp.querySelectorAll('[data-t8-buynow-error]').forEach(function (e) {
        var mine = !!btn && !!e.closest('[data-t8-sticky]') === !!btn.closest('[data-t8-sticky]');
        e.textContent = mine ? (msg || '') : ''; e.hidden = !(mine && msg);
      });
    }
    function summary() {
      var parts = [];
      form.querySelectorAll('fieldset.t8-pdp__opt').forEach(function (fs) {
        if (fs.hidden) return;
        var r = fs.querySelector('input[type="radio"]:checked'); if (!r) return;
        var pill = r.closest('label') && r.closest('label').querySelector('.t8-pdp__pilltext');
        var lab = String(r.dataset.label || (pill && pill.textContent) || r.value).replace(/\s+/g, ' ').trim();
        if (fs.classList.contains('t8-pdp__opt--mount')) { if (/^(yes|with)/i.test(lab)) parts.push(cfg.stickyMount || 'with mount'); return; }
        if (fs.classList.contains('t8-pdp__opt--size')) lab = r.value.replace(/\s*[x×]\s*/i, ' × ');
        if (fs.classList.contains('t8-pdp__opt--frame') && cfg.stickyFrame && !/frame|rolled|wrap|float/i.test(lab)) lab += ' ' + cfg.stickyFrame;
        if (lab) parts.push(lab);
      });
      return parts.join(' · ');
    }
    /* mirror the main Add to Cart (sold out / unavailable / adding / added / WhatsApp) onto the bar and the Buy Now buttons */
    function paint() {
      var label = atcText ? atcText.textContent : '', off = !atc || atc.disabled;
      var adding = label === (cfg.addingText || 'Adding…'), wa = form.dataset.wa === '1';
      var soldOut = off && !adding;
      if (sAtc) { sAtc.disabled = off; setText(sAtc, label); sAtc.classList.toggle('is-added', !!atc && atc.classList.contains('is-added')); }
      buyBtns.forEach(function (b) {
        b.hidden = wa;
        if (busy) return;
        b.disabled = off;
        setText(b, soldOut && b.closest('[data-t8-sticky]') ? (cfg.soldOutText || 'Sold out') : buyLabel);
      });
      if (sPrice && priceEl) sPrice.textContent = priceEl.textContent;
      if (sCompare && compareEl) { sCompare.hidden = compareEl.hidden; sCompare.textContent = compareEl.textContent; }
      var sDisc = bar && bar.querySelector('[data-t8-sticky-disc]'), sDiscText = bar && bar.querySelector('[data-t8-sticky-disc-text]');
      var mDisc = pdp.querySelector('[data-t8-discount]'), mDiscText = pdp.querySelector('[data-t8-discount-text]');
      if (sDisc && mDisc) { sDisc.hidden = mDisc.hidden; if (sDiscText && mDiscText) sDiscText.textContent = mDiscText.textContent; }
      if (sOpts) { var s = summary(); sOpts.textContent = s; sOpts.hidden = !s; }
    }
    var queued = false;
    function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; paint(); }); }
    pdp.addEventListener('tamyra:variant', schedule);
    form.addEventListener('change', function () { setErr(''); schedule(); });
    if (atc && window.MutationObserver) new MutationObserver(schedule).observe(atc, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, characterData: true, subtree: true });
    paint();

    /* Buy Now */
    function buyNow(btn) {
      if (busy) return;
      if (form.dataset.wa === '1') { if (form.requestSubmit) form.requestSubmit(); return; }   /* made-to-order size: same WhatsApp flow as Add to Cart */
      if (!idInput || !Number(idInput.value) || (atc && atc.disabled)) return;
      setErr('');
      busy = true;
      buyBtns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); setText(b, cfg.addingText || 'Adding…'); });
      var reset = function () { busy = false; buyBtns.forEach(function (b) { b.removeAttribute('aria-busy'); }); paint(); };
      if (cfg.previewBuyNow) {   /* static preview: no cart endpoint */
        var fd = {}; new FormData(form).forEach(function (v, k) { fd[k] = v; });
        console.log('[t8 preview] Buy Now → /cart/add.js then /checkout', fd);
        setTimeout(reset, 900);
        return;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { if (!r.ok) throw new Error(d.description || d.message || ''); return d; }); })
        .then(function () { window.location = root + 'checkout'; })
        .catch(function (err) { reset(); setErr((err && err.message) || cfg.buyNowError || "Couldn't start checkout. Please try again.", btn); });
    }
    buyBtns.forEach(function (b) { b.addEventListener('click', function () { buyNow(b); }); });
    window.addEventListener('pageshow', function (e) { if (e.persisted && busy) { busy = false; buyBtns.forEach(function (b) { b.removeAttribute('aria-busy'); }); paint(); } });

    if (!bar) return;
    /* bar Add to Cart = the main form's submit (same handler, same selection) */
    if (sAtc) sAtc.addEventListener('click', function () {
      if (!atc || atc.disabled) return;
      if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
    });

    /* show / hide */
    var atcPast = false, footIn = false, atcIn = false, shown = false;
    var mq = window.matchMedia('(max-width: 768px)');   /* phones: bar always on, except while the real Add to Cart is on screen */
    function setShown(on) {
      if (on === shown) return; shown = on;
      if (!on && bar.contains(document.activeElement) && atc) atc.focus({ preventScroll: true });
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', String(!on));
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.body.classList.toggle('t8-sticky-on', on);
    }
    function check() { setShown(mq.matches ? !atcIn : (atcPast && !footIn)); }
    if (mq.addEventListener) mq.addEventListener('change', check); else if (mq.addListener) mq.addListener(check);
    function ioOpts(m) { return { rootMargin: m }; }   /* (ignored in a cross-origin iframe such as the theme editor; the rect checks below still hold for normal scrolling) */
    if ('IntersectionObserver' in window && atc) {
      /* the root is stretched far below (ATC) / above (footer) the viewport, so a jump past either one (anchor link,
         scroll restore) still crosses the threshold: "not intersecting" = scrolled above it / not reached yet */
      new IntersectionObserver(function (es) { es.forEach(function (e) { atcPast = !e.isIntersecting && e.boundingClientRect.top < 0; }); check(); }, ioOpts('0px 0px 100000px 0px')).observe(atc);
      /* plain viewport observer: is the main Add to Cart actually visible right now? (any part of it) */
      new IntersectionObserver(function (es) { es.forEach(function (e) { atcIn = e.isIntersecting; }); check(); }).observe(atc);
      var foot = document.querySelector('.shopify-section-t8-footer') || document.querySelector('.t8-footer') || document.querySelector('body > footer, .shopify-section-group-footer-group, footer.footer');   /* the site footer, not a card's <footer> */
      if (foot) new IntersectionObserver(function (es) { es.forEach(function (e) { footIn = e.isIntersecting || e.boundingClientRect.bottom < 0; }); check(); }, ioOpts('100000px 0px 0px 0px')).observe(foot);
    }
    /* bar height → --t8-sticky-h (page padding on phones, lifts any floating WhatsApp button) */
    var setH = function () { document.documentElement.style.setProperty('--t8-sticky-h', bar.offsetHeight + 'px'); };
    setH();
    if (window.ResizeObserver) new ResizeObserver(setH).observe(bar); else window.addEventListener('resize', setH);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
